import React, { useEffect, useState } from 'react';
import { Grid, Paper } from '@material-ui/core';
import { createUseStyles } from 'src/theming';

const useStyles = createUseStyles({
  root: {
    paddingTop: 25,
    paddingBottom: 25,
  },
  paper: {
    padding: 12,
    textAlign: 'center',
  },
  subTitle: {
    color: '#3c3c3c',
    fontWeight: 'bold',
  },
  title: {
    color: 'red',
    fontWeight: 'bold',
  },
});

const SurveyConfirmation = ({ location: { search } }) => {
  const classes = useStyles();
  const [error, setError] = useState<string>();

  useEffect(() => {
    const searchParams = new URLSearchParams(search);
    setError(searchParams.get('error') || undefined);
  }, [search]);

  return (
    <Grid className={classes.root} container justifyContent='center'>
      <Grid item xs={10} sm={6} md={4}>
        <Grid container justifyContent='center'>
          <Grid item xs={12}>
            <Paper className={classes.paper}>
              {!error ? (
                <>
                  <h1 className={classes.title}>Avis déposé</h1>
                  <h4 className={classes.subTitle}>MERCI !</h4>
                  <p>
                    Votre satisfaction est au cœur de nos préoccupations, grace à votre évaluation nous allons pouvoir
                    améliorer notre service. Merci pour votre confiance. A bientôt.
                  </p>
                </>
              ) : (
                <div>Vous avez déjà déposé votre avis !</div>
              )}
            </Paper>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default SurveyConfirmation;
